import React from "react";
import commonStyles from "../../containers/settings/settingsEditCommon.css";

export interface Props {
  subtitle?: string;
  description?: string;
  descriptionElement?: JSX.Element;
}

export const SubtitleDescription: React.SFC<Props> = ({
  subtitle,
  description,
  descriptionElement
}) => (
  <div className={commonStyles["subtitle-description"]}>
    {subtitle && <div className={commonStyles.subtitle}>{subtitle}</div>}
    {description && (
      <div className={commonStyles.description} dangerouslySetInnerHTML={{ __html: description }} />
    )}
    {descriptionElement && <div className={commonStyles.description}>{descriptionElement}</div>}
  </div>
);
